import React from 'react';
import moment from 'moment';

import { FileBox, MCButton, SelectField, TextField } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';
import DefaultPdfImg from 'src/assets/images/default-pdf-img.png';

import { lang, rangeToSelectList, remCss } from 'src/helpers';
import model from './model';
import constants from 'src/constants';

class UploadForm extends BaseComponent {
  componentDidMount() {
    model.resetForm();
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  add = (e) => {
    e.preventDefault();
    const { files, hide, upload } = this.props;
    model.validateSave(() => {
      hide();
      if (upload) return upload();
      model.setState({
        updating: true,
        certificateFiles: [
          ...model.state.certificateFiles,
          {
            counter: Date.now(),
            file: files[0],
            title: model.state.title,
            promotionYear: model.state.promotionYear,
            specialty: model.state.specialty
          }
        ]
      });
    });
  };

  render() {
    const { closeBtn, files } = this.props;
    const apiId = 'update';
    const createState = model.getApiState(apiId);
    const { loading, invalid } = createState;
    const year = moment().year();

    return (
      <div className={'mc-popup-contain'} style={{ maxWidth: remCss(400) }}>
        <div className='mc-modal-header'>
          <div className='mc-popup-title'>{lang.t('Upload Certificate')}</div>
          {closeBtn}
        </div>
        <form className='mc-modal-body mc-flex-20-col' onSubmit={this.add}>
          <FileBox
            className={'mc-grow'}
            template={1}
            file={files[0]}
            thumbnail={DefaultPdfImg}
            onClose={null}
            showFileName={false}
            styles={{ height: remCss(180), width: remCss(340) }}
          />
          <TextField
            template={6}
            name={'title'}
            placeholder={'Title'}
            value={model.input('title')}
            onChange={(n, v) => {
              model.resetApiState(apiId);
              model.handleChange(n, v);
            }}
            invalid={invalid}
          />
          <SelectField
            template={6}
            isClearable={false}
            options={rangeToSelectList(year - 70, year, true)}
            value={model.input('promotionYear')}
            onChange={(n, v) => {
              model.resetApiState(apiId);
              model.handleChange(n, v);
            }}
            name={'promotionYear'}
            placeholder={'Promotion year'}
            invalid={invalid}
          />
          <SelectField
            template={6}
            isClearable={false}
            options={constants.general.specialist}
            name={'specialty'}
            placeholder={'Specialty'}
            value={model.input('specialty')}
            onChange={(n, v) => {
              model.resetApiState(apiId);
              model.handleChange(n, v);
            }}
            invalid={invalid}
          />
        </form>
        <div className='mc-modal-footer mc-flex'>
          <div className='mc-grow' />
          <MCButton
            medium
            primary
            radius
            light
            disabled={loading}
            type={'button'}
            onClick={this.props.hide}
            label={'Cancel'}
          />
          <MCButton
            medium
            primary
            radius
            dark
            disabled={loading}
            type={'button'}
            onClick={this.add}
            label={'Upload'}
          />
        </div>
      </div>
    );
  }
}

export default UploadForm;
